import Head from 'next/head';
import React from 'react';
import PageHero from '../layouts/PageHero';
import faqSchema from '../utils/faqSchema';
import { FAQ_PAGE, FAQ_PAGE_INTERFACE } from '../api/faqPage';
import client from '../apollo-client';
import Faqs from '../components/Contact/Faqs';
import Adventure from '../components/Reviews/Adventure';
import Newsletter from '../layouts/Newsletter/Newsletter';
import FEATUREDEXPERIENCES, {
  FEATURED_EXPERIENCES_INTERFACE,
  HOMEPAFE
} from '../api/featuredexperiences';
import { CITIES, CITIES_PAGE_INTERFACE } from '../api/citiesPage';
import {
  DAYTOURS_PAGE,
  DAYTOURS_PAGE_INTERFACE,
  DAY_TOUR_INTERFACE
} from '../api/dayToursPage';
import { CARDMEDIAINTERFACE } from '../api/commonInterfaces';
import FeaturedExperiences from '../components/FeaturedExperiences/FeaturedExperiences';
import { replaceTripshepherdWithSeeSight } from '../utils/trip-sheppered-text';
interface FAQPAGE {
  faqs: FAQ_PAGE_INTERFACE;
  featuredExp: HOMEPAFE;
  headData: {
    title: string;
    metaDescription: string;
  };
  citydropdown: [
    {
      id: string;
      name: string;
      slug: string;
    }
  ];
  cities: [
    {
      city: {
        id: string;
        name: string;
        slug: string;
        cardSnippet: string;
        cardMedia: [CARDMEDIAINTERFACE];
      };
    }
  ];
  dayTour: DAY_TOUR_INTERFACE;
}
//
const faq = ({ faqs, featuredExp, citydropdown, headData }: FAQPAGE) => {
  const { faqPage } = faqs || {};
  if (!faqPage) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center">
        <p>FAQ data is not available. Please try again later.</p>
      </div>
    );
  }
  return (
    <>
      <Head>
        <meta
          name="og:title"
          content={replaceTripshepherdWithSeeSight(headData?.title)}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
        <meta
          name="og:description"
          content={
            'Explore our FAQs for detailed information about booking, tour schedules, cancellations, and everything you need to know before your adventure. '
          }
        />
        <title>{replaceTripshepherdWithSeeSight(headData?.title)}</title>

        <meta
          name="description"
          content={
            'Explore our FAQs for detailed information about booking, tour schedules, cancellations, and everything you need to know before your adventure. '
          }
        />
        <link href={'https://www.seesight-tours.com/faq'} rel="canonical" />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <PageHero
        trustworthy={false}
        video={false}
        title={faqPage?.header?.toLocaleUpperCase() || 'FAQ'}
        snippet=""
        media={faqPage?.heroMedia?.[0]?.url || ''}
      />
      <div className="w-[90%] lg:w-[85%] 3xl:w-[70%] max-w-[1750px] mx-auto mt-8 mb-16 lg:mb-28">
        <Faqs
          header={faqPage?.header || ''}
          subHeader={faqPage?.sectionSubheader || ''}
          content={faqPage?.sectionContent || ''}
          faqRef={null}
        />
      </div>
      <FeaturedExperiences
        featuredExp={featuredExp}
        citydropdown={citydropdown}
      />
      <Adventure />
      <Newsletter />
    </>
  );
};
export async function getStaticProps() {
  try {
    const { data: faqs, error } = await client.query<FAQ_PAGE_INTERFACE>({
      query: FAQ_PAGE
    });

    if (error) {
      console.error('FAQ query error:', error);
      throw new Error(`FAQ query failed: ${error.message}`);
    }

    if (!faqs || !faqs.faqPage) {
      console.error('FAQ data is missing or malformed:', faqs);
      throw new Error('FAQ data is missing or malformed');
    }

    const { data } = await client.query<FEATURED_EXPERIENCES_INTERFACE>({
      query: FEATUREDEXPERIENCES,
      variables: {
        dayTours: true,
        multiday: true,
        airportTransfers: false
      }
    });

    const { data: citiesData } = await client.query<CITIES_PAGE_INTERFACE>(
      CITIES
    );

    const { data: { dayTour } = {} } =
      await client.query<DAYTOURS_PAGE_INTERFACE>({
        query: DAYTOURS_PAGE
      });

    return {
      props: {
        faqs: JSON.parse(replaceTripshepherdWithSeeSight(JSON.stringify(faqs))),
        featuredExp: JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.homePage))
        ),
        citydropdown: JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.citiesDropdown))
        ),
        cities: JSON.parse(
          replaceTripshepherdWithSeeSight(
            JSON.stringify(citiesData.citiesPage.featured)
          )
        ),
        dayTour: JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(dayTour))
        ),
        headData: {
          title: faqs.faqPage.pageTitle,
          meta: faqs.faqPage.metaDescription
        }
      }
    };
  } catch (error) {
    console.error('Error in getStaticProps:', error);

    // Return a fallback or redirect to an error page
    return {
      notFound: true
    };
  }
}
export default faq;
